import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import MembershipCheckoutForm from './MembershipCheckoutForm';
import { RETURN_PATHS } from '../../service/checkoutReturn';

import '../../styles/App.css';

const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
const stripePromise = publishableKey ? loadStripe(publishableKey) : null;

// Stripe Elements checkout for the membership enroll flow. clientSecret
// comes from POST /api/membership/enroll — a PaymentIntent secret for the
// one-time annual plan, or a subscription-setup secret for monthly (see
// MembershipCheckoutForm for how the two are told apart).
export default function MembershipCheckout({
  clientSecret,
  returnPath = RETURN_PATHS.membership,
  submitLabel,
  summary,
}) {
  if (!clientSecret) return null;
  if (!stripePromise) {
    return <p>Payments are not available right now. Please try again later.</p>;
  }

  const options = { clientSecret, appearance: { theme: 'stripe' } };

  return (
    <Elements options={options} stripe={stripePromise}>
      <MembershipCheckoutForm
        clientSecret={clientSecret}
        returnPath={returnPath}
        submitLabel={submitLabel}
        summary={summary}
      />
    </Elements>
  );
}
